import { UserRole, CernerRole } from '@lmc/ts-common'
import { getNominative } from 'common/utils'

const ROLE_OPTIONS_CAREHOME = [
  { label: 'Carer', value: UserRole.carer },
  { label: 'Senior Carer', value: UserRole.seniorCarer },
  { label: 'Admin', value: UserRole.careHomeAdmin },
]

const ROLE_OPTIONS_GROUP = [
  { label: 'Group Admin', value: UserRole.groupAdmin },
  { label: 'Group Manager', value: UserRole.groupManager },
]

const ROLE_NOTE_CAREHOME = (preferredPeopleNominative: string) =>
  `Carers can only access the Carer App, while Senior Carers also have limited access to the Care Office (viewing ${getNominative(
    preferredPeopleNominative || '',
    'Resident'
  )} and Report information only). Admins have full access to the Care Office.`
const ROLE_NOTE_GROUP =
  'Group Admins can fully access the care office. Group Managers will not be able to edit any information.'

export const getRoleFieldsProps = (
  initial?: Record<string, unknown> | undefined,
  role?: UserRole,
  preferredPeopleNominative = ''
) => {
  const isGroupUser =
    initial?.role === UserRole.groupAdmin ||
    initial?.role === UserRole.groupManager
  const ROLE_OPTIONS = isGroupUser ? ROLE_OPTIONS_GROUP : ROLE_OPTIONS_CAREHOME

  const ROLE_NOTE =
    role === UserRole.careHomeAdmin
      ? ROLE_NOTE_CAREHOME(preferredPeopleNominative)
      : ROLE_NOTE_GROUP

  return { ROLE_NOTE, ROLE_OPTIONS, isGroupUser }
}

export const CARE_MANAGEMENT_LABEL = 'Care Management'

export const CERNER_ROLE_OPTIONS = [
  { value: CernerRole.NoAccess, label: 'No Access' },
  { value: CernerRole.SeniorCarer, label: 'Senior Carer Access' },
  { value: CernerRole.Admin, label: 'Admin Access' },
  { value: CernerRole.RegisteredManager, label: 'Registered Manager Access' },
]

export const getPermissionBooleanByTemplate = (
  label?: string,
  templates?: { id: string; label: string }[]
) => templates?.find((item) => item.label === label)
